import { render, staticRenderFns } from "./FilterRoles.vue?vue&type=template&id=4b64431e&scoped=true"
import script from "./FilterRoles.vue?vue&type=script&lang=js"
export * from "./FilterRoles.vue?vue&type=script&lang=js"
import style0 from "./FilterRoles.vue?vue&type=style&index=0&id=4b64431e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64431e",
  null
  
)

export default component.exports